import { AppRegistry } from 'react-native';
import App from './App.web';

AppRegistry.registerComponent('TipsyHost', () => App);

AppRegistry.runApplication('TipsyHost', {
  rootTag: document.getElementById('root'),
});
